/* eslint-disable */
// import { validation } from './commonValidation';
import toast from './toast';

const editUsr = () => {
  const editForm = document.querySelector('.js-edit-account-form');
  const confirmation = document.querySelector('.js-edit-account-confirmation');
  const body = document.querySelector('body');
  const nameInput = document.querySelector('.js-registration-name-label input');
  const surnameInput = document.querySelector(
    '.js-registration-surname-label input',
  );
  const emailInput = document.querySelector(
    '.js-registration-email-label input',
  );

  const validateEmail = () => {
    const emailLabel = document.querySelector('.js-validated-email-label');
    const emailInput = document.querySelector('.js-validated-email-label input');
    const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!re.test(emailInput.value.toLowerCase())) {
      emailLabel.classList.add('has-error');
      return false;
    } else {
      emailLabel.classList.remove('has-error');
      return true;
    }
  };

  const validateFirstName = () => {
    const firstNameLabel = document.querySelector('.js-validated-name-label');
    const firstNameInput = document.querySelector('.js-validated-name-label input');
    const re = /^[\s\p{L}]+$/u;
    if (firstNameInput.value && !re.test(firstNameInput.value)) {
      firstNameLabel.classList.add('has-error');
      return false;
    } else {
      firstNameLabel.classList.remove('has-error');
      return true;
    }
  };

  const validateLastName = () => {
    const lastNameLabel = document.querySelector('.js-validated-surname-label');
    const lastNameInput = document.querySelector('.js-validated-surname-label input');
    const re = /^[\s\p{L}-]+$/u;
    if (lastNameInput.value && !re.test(lastNameInput.value)) {
      lastNameLabel.classList.add('has-error');
      return false;
    } else {
      lastNameLabel.classList.remove('has-error');
      return true;
    }
  };

  const sendEditForm = e => {
    e.preventDefault();

    if (validateEmail() && validateFirstName() && validateLastName()) {
      const ajax_url = document.querySelector('meta[name="adjx"]').content;
      let ajaxData = {
        action: 'ks_edit_user',
        ks_user_mail: emailInput.value,
        ks_user_firstname: nameInput.value,
        ks_user_lastname: surnameInput.value,
      };

      let ajaxParameters = Object.entries(ajaxData)
        .map(e => e.join('='))
        .join('&');

      let request = new XMLHttpRequest();
      request.open('POST', ajax_url, true);

      request.setRequestHeader(
        'Content-Type',
        'application/x-www-form-urlencoded;',
      );

      request.onload = function() {
        if (this.status >= 200 && this.status < 400) {
          const response = JSON.parse(request.response);
          const toastWrapper = document.createElement('div');

          toastWrapper.innerHTML = response.message;
          body.append(toastWrapper);
          if (response.success) {
            confirmation.classList.remove('u-hidden');
            if (response.success && response.redirect) {
              setTimeout(() => {
                window.location.href = response.redirect;
              }, 3000);
            }
          }
          toast();
        }
      };

      request.onerror = function() {};

      request.send(ajaxParameters);
    }
  };

  if (editForm) {
    nameInput.addEventListener('input', validateFirstName);
    surnameInput.addEventListener('input', validateLastName);
    emailInput.addEventListener('input', validateEmail);
    editForm.addEventListener('submit', sendEditForm);
  }
};

export default editUsr;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/editUser.js